<template>
  <v-tooltip
    top :disabled="noTooltip"
    :color="player ? 'grey800' : color"
    content-class="rounded-0 battle-player-tooltip"
  >
    <template #activator="{ on }">
      <div class="d-inline-block" :class="$vnode.data.staticClass" v-on="on">
        <UserAvatar
          :style="{'--color': color}"
          :user="player || {}"
          :size="size"
          class="battle-player"
        >
          <template #empty>
            <div class="empty-ctn d-flex align-center justify-center">
              <v-btn
                :color="color"
                tile :ripple="false" icon
                @click.native.prevent="$emit('join')"
              >
                <fai v-if="isCursed" :icon="['fad', 'skull-crossbones']" class="text-h6" />
                <fai v-else :icon="['fas', 'sign-in-alt']" class="text-body-1" />
              </v-btn>
            </div>
          </template>
        </UserAvatar>
      </div>
    </template>

    <Username v-if="player" :user="player" />
    <span v-else class="font-weight-bold text-caption">Join battle</span>
  </v-tooltip>
</template>

<script>
import { TEAM_COLORS } from '../utils'

export default {
  props: {
    game: {
      type: Object,
      default: null,
    },
    player: {
      type: Object,
      default: null,
    },
    color: {
      type: String,
      default: TEAM_COLORS[0],
    },
    size: {
      type: Number,
      default: 48,
    },
    noTooltip: Boolean,
  },
  computed: {
    isCursed() {
      return !!this.game?.isCursed
    },
  },
}
</script>

<style lang="scss" scoped>
.battle-player-tooltip.menuable__content__active {
  opacity: 1 !important;
}

.battle-player {
  overflow: visible;
  transform: rotate(-5deg);

  .empty-ctn {
    z-index: 1;
    width: 100%;
    height: 100%;
    background: grey(400);

    .v-btn {
      width: 100%;
      height: 100%;
    }
  }

  &::before {
    position: absolute;
    top: 4px;
    left: 4px;
    width: 100%;
    height: 100%;
    background: var(--color);
    content: ' ';
  }
}
</style>
